import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { MatApoyo } from "../Generals";
import {Row, Col, Card} from "antd";


export default function Lesson2({ data, objEntidad, origen }) {
  const isMounted = useRef(true);
  //Se obtiene el Entidad seleccionada del store de redux
  const { idEntidad } = useSelector((state) => state.entidad);
  //State-Redux

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  if(idEntidad!==undefined){
    localStorage.setItem('idEntidad', idEntidad);
  }

  useEffect(() => {
    window.scrollTo(0, 0); // para posicionar el scroll al inicio
  }, []);

  //función que ontiene los datos de la entidad dependiendo si se visualiza la lección dsde el curso o desde materiales de capacitación
  /*const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ?objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }*/
  return (
    <>
      <div className="texto_parrafo">
        <p>
          Nuestro país es una República representativa, democrática, laica y federal, integrada por 32 
          entidades federativas, libres y soberanas pero unidas en una federación, por lo que se ajusta 
          al esquema de división y separación de funciones entre los poderes.
        </p>
        <p>
          En el siguiente material te explicamos cada uno de los Poderes de la Unión.
        </p>

        <p>{data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}</p>

        <p>
          <b>Como resultado de la reforma constitucional de 2024</b>, se crean dos nuevos órganos, 
          el Tribunal de Disciplina Judicial (TDJ) y el Órgano de Administración Judicial (OAJ), 
          por lo que <b>el PJF modifica su estructura y funcionamiento a partir de 2025.</b>
        </p>

        <p>{data && data.indexOf(2) && <MatApoyo array={[data[2]]} />}</p>

        <p>
          Abre los siguientes enlaces que te llevarán a distintas infografías, para que identifiques las 
          características de cada uno de los órganos que conforman el Poder Judicial de la Federación.
        </p>
        <Row gutter={[16, 24]}>
          <Col md={6} sm={12} xs={12} className="gutter-row">
           <Card className="card-lesson">
           <p className="text-card-lesson">{data && data.indexOf(3) && <MatApoyo array={[data[3]]} />}</p>
           </Card>
          </Col>
          <Col md={6} sm={12} xs={12} className="gutter-row">
           <Card className="card-lesson">
           <p className="text-card-lesson">{data && data.indexOf(4) && <MatApoyo array={[data[4]]} />}</p>
           </Card>
          </Col>
          <Col md={6} sm={12} xs={12} className="gutter-row">
           <Card className="card-lesson">
              <p className="text-card-lesson">{data && data.indexOf(5) && <MatApoyo array={[data[5]]} />}</p>
           </Card>
          </Col>
          <Col md={6} sm={12} xs={12} className="gutter-row">
           <Card className="card-lesson">
           <p className="text-card-lesson">{data && data.indexOf(6) && <MatApoyo array={[data[6]]} />}</p>
           </Card>
          </Col>
          <Col md={6} sm={12} xs={12} className="gutter-row">
           <Card className="card-lesson">
           <p className="text-card-lesson">{data && data.indexOf(7) && <MatApoyo array={[data[7]]} />}</p>
           </Card>
          </Col>
          <Col md={6} sm={12} xs={12} className="gutter-row">
           <Card className="card-lesson">
           <p className="text-card-lesson">{data && data.indexOf(8) && <MatApoyo array={[data[8]]} />}</p>
           </Card>
          </Col>
          <Col md={6} sm={12} xs={12} className="gutter-row">
           <Card className="card-lesson">
              <p className="text-card-lesson">{data && data.indexOf(9) && <MatApoyo array={[data[9]]} />}</p>
           </Card>
          </Col>
          <Col md={6} sm={12} xs={12} className="gutter-row">
           <Card className="card-lesson">
           <p className="text-card-lesson">{data && data.indexOf(10) && <MatApoyo array={[data[10]]} />}</p>
           </Card>
          </Col>
        </Row>
        <br></br>
        <div className="div-bordered">
          <p>
            El <b>Consejo de la Judicatura Federal</b> es un órgano del PJF encargado de la administración, vigilancia y 
            disciplina del sistema judicial, con excepción de la Suprema Corte de Justicia de la Nación (SCJN) y del 
            Tribunal Electoral del Poder Judicial de la Federación (TEPJF). Su objetivo principal es garantizar el 
            funcionamiento eficiente, imparcial e independiente de los órganos judiciales bajo su responsabilidad; 
            <b>este órgano continuará ejerciendo las facultades y atribuciones de administración, vigilancia y disciplina 
            del Poder Judicial hasta que se creen el TDJ y el OAJ.</b>
          </p>
        </div>
        <br></br>
        <p>
          Para reforzar tu aprendizaje te invitamos a realizar la actividad interactiva.
        </p>
        
        <p>{data && data.indexOf(11) && <MatApoyo array={[data[11]]} />}</p>
        <p>
          A continuación, te presentamos el ámbito geográfico de actuación de los órganos del Poder Judicial de la Federación.
        </p>

        <p>{data && data.indexOf(12) && <MatApoyo array={[data[12]]} />}</p>
        
        <div className="div-bordered">
          <p>
            Para la organización de las elecciones fue necesario <b>adaptar el marco geográfico electoral vigente con los circuitos 
            judiciales</b> de los cargos que se elegirán, por lo que el INE <b>armonizó los 32 circuitos judiciales en 60 Distritos 
            Judiciales Electorales</b>, los cuales coinciden con los Distritos Electorales Federales.
          </p>
        </div>
        <br></br>
        {/*La siguientes condiciones consideran todas las 32 entidades, para como "El estado de México""*/
        /*Las autoridades electorales locales {parseInt(getDataEntidad().idEntidad) === 15 
                ? capitalizeWord(getDataEntidad().entidad).replace('el', 'del') 
                : 'de '+capitalizeWord(getDataEntidad().entidad)} son {getAutoridadesEntidadL2(parseInt(getDataEntidad().idEntidad))}
        </p>*/}
        
        <p>
          Las candidatas y los candidatos deberán cumplir los requisitos constitucionales y legales para cada cargo, 
          señalados en las convocatorias, lo cuales puedes consultar en la siguiente infografía.
        </p>
        
        <p>{data && data.indexOf(13) && <MatApoyo array={[data[13]]} />}</p>

        <p>
          Las personas candidatas tienen derechos y obligaciones, que deben conocer y respetar.
        </p>

        <p>{data && data.indexOf(14) && <MatApoyo array={[data[14]]} />}</p>

        <p>
          Pon a prueba tus conocimientos con la siguiente actividad interactiva. Responde las preguntas, evalúa tus 
          respuestas y refuerza lo aprendido. ¡Puedes intentarlo cuantas veces lo necesites!
        </p>

        <p>{data && data.indexOf(15) && <MatApoyo array={[data[15]]} />}</p>

        <p>
          Consulta la presentación para acceder a un resumen claro y preciso del tema. Este material está diseñado para 
          complementar tu aprendizaje y fortalecer tu comprensión de los conceptos.
        </p>
        <p>{data && data.indexOf(16) && <MatApoyo array={[data[16]]} />}</p>

        <p>
        Para profundizar tus conocimientos sobre el PJF, revisa el <div className="textoResaltado2" style={{display: "inline"}}> tema 2 de la </div>
        {data && data.indexOf(17) && <MatApoyo array={[data[17]]} tipo={1}/>}, que está disponible en los materiales
         de consulta de este curso.
        </p>
        <div className="div-bordered">
          <p>
            Es importante que tengas en cuenta que, en <b>algunas entidades del país, se celebrarán elecciones locales 
            para elegir a las y los integrantes de su Poder Judicial Local, es decir, se llevarán a cabo elecciones 
            concurrentes con las del Poder Judicial Federal.</b>
          </p>
        </div>
        <br></br>
        <p>
        PSi acudes a observar una elección concurrente del Poder Judicial, te recomendamos revisar 
        el  <div className="textoResaltado2" style={{display: "inline"}}>tema 1 de la Adenda a la Guía 
        para las y los observadores electorales de cada entidad con elección extraordinaria del Poder 
        Judicial Local en 2025</div>, en ella encontrarás la estructura y características de los órganos 
        que integran el Poder Judicial Local. La Adenda está disponible en los materiales de consulta 
        de este curso.
        </p>
        <p>
          Ahora que ya conoces sobre el PJF, realiza la actividad de autoevaluación para reforzar tu aprendizaje. 
          Después, continúa con la siguiente lección.
        </p>
      </div>
    </>
  );
}
